<template>
  <div class="CardBag">
    <div class="CardBag-background">
      <div class="payment-AppTitle">
        <img src="../../public/obraoag/paymentReturn.png" alt="" @click="BackLevel()">
        卡包
      </div>
      <div class="CardBag-fill"></div>
      <div v-if="this.cacaus == '0'">
        <div v-for="ercardmber in cardmber" :key="ercardmber.ID" @click="careus(ercardmber.cardtypename,ercardmber.cnumber,ercardmber.totalamount,ercardmber.totalintegral,ercardmber.state,ercardmber.lockamount,ercardmber.totalintegral)">
          <div class="CardBag-whole" v-if="!(ercardmber.cardtype == '1')">
            <div class="CardBag-DefaCard" :class="ercardmber.cardtypename == '尊卡' || ercardmber.cardtypename == '欧宝卡' ? 'CardBag-respect' : 'CardBag-oberka'">
              <div class="CardBag-DefaCard-title">
                <p v-if="ercardmber.state == '0'">{{ercardmber.cardtypename}}<span class="CardBag-DefaCard-title-state">未激活</span></p>
                <p v-else-if="ercardmber.state == '1'">{{ercardmber.cardtypename}}<span class="CardBag-DefaCard-title-state">正常</span></p>
                <p v-else-if="ercardmber.state == '2'">{{ercardmber.cardtypename}}<span class="CardBag-DefaCard-title-state">挂失</span></p>
                <p>NO.{{ercardmber.cnumber}}</p>
              </div>
              <div class="CardBag-DefaCard-title">
                <p>余额: {{Math.floor(ercardmber.totalamount * 100) / 100 || '0'}}</p>
                <p v-if="ercardmber.cardtypename != '欧宝卡'">积分: {{Math.floor(ercardmber.totalintegral * 100) / 100 || '0'}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="this.cacaus == '1'">
        <div v-for="ercardmber in cardmber" :key="ercardmber.ID" @click="careus(ercardmber.cardtypename,ercardmber.cnumber,ercardmber.totalamount,ercardmber.totalintegral,ercardmber.state,ercardmber.lockamount,ercardmber.totalintegral)">
          <div class="CardBag-whole" v-if="ercardmber.cardtype == '1'">
            <div class="CardBag-DefaCard" :class="ercardmber.cardtypename == '尊卡' || ercardmber.cardtypename == '欧宝卡' ? 'CardBag-respect' : 'CardBag-oberka'">
              <div class="CardBag-DefaCard-title">
                <p v-if="ercardmber.state == '0'">{{ercardmber.cardtypename}}<span class="CardBag-DefaCard-title-state">未激活</span></p>
                <p v-else-if="ercardmber.state == '1'">{{ercardmber.cardtypename}}<span class="CardBag-DefaCard-title-state">正常</span></p>
                <p v-else-if="ercardmber.state == '2'">{{ercardmber.cardtypename}}<span class="CardBag-DefaCard-title-state">挂失</span></p>
                <p>NO.{{ercardmber.cnumber}}</p>
              </div>
              <div class="CardBag-DefaCard-title">
                <p>余额: {{Math.floor(ercardmber.totalamount * 100) / 100 || '0'}}</p>
                <p v-if="ercardmber.cardtypename != '欧宝卡'">积分: {{Math.floor(ercardmber.totalintegral * 100) / 100 || '0'}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="this.cacaus == '3'">
        <div v-for="ercardmber in cardmber" :key="ercardmber.ID" @click="careus(ercardmber.cardtypename,ercardmber.cnumber,ercardmber.totalamount,ercardmber.totalintegral,ercardmber.state,ercardmber.lockamount,ercardmber.totalintegral)">
          <div class="CardBag-whole" v-if="!(ercardmber.cardtype == '5')">
            <div class="CardBag-DefaCard" :class="ercardmber.cardtypename == '尊卡' || ercardmber.cardtypename == '欧宝卡' ? 'CardBag-respect' : 'CardBag-oberka'">
              <div class="CardBag-DefaCard-title">
                <p v-if="ercardmber.state == '0'">{{ercardmber.cardtypename}}<span class="CardBag-DefaCard-title-state">未激活</span></p>
                <p v-else-if="ercardmber.state == '1'">{{ercardmber.cardtypename}}<span class="CardBag-DefaCard-title-state">正常</span></p>
                <p v-else-if="ercardmber.state == '2'">{{ercardmber.cardtypename}}<span class="CardBag-DefaCard-title-state">挂失</span></p>
                <p>NO.{{ercardmber.cnumber}}</p>
              </div>
              <div class="CardBag-DefaCard-title">
                <p>余额: {{Math.floor(ercardmber.totalamount * 100) / 100 || '0'}}</p>
                <p v-if="ercardmber.cardtypename != '欧宝卡'">积分: {{Math.floor(ercardmber.totalintegral * 100) / 100 || '0'}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="CardBag-whole" v-for="ercardmber in cardmber" :key="ercardmber.ID" @click="careus(ercardmber.cardtypename,ercardmber.cnumber,ercardmber.totalamount,ercardmber.totalintegral,ercardmber.state,ercardmber.lockamount,ercardmber.totalintegral)">
          <div class="CardBag-DefaCard" :class="ercardmber.cardtypename == '尊卡' || ercardmber.cardtypename == '欧宝卡' ? 'CardBag-respect' : 'CardBag-oberka'">
            <div class="CardBag-DefaCard-title">
              <p v-if="ercardmber.state == '0'">{{ercardmber.cardtypename}}<span class="CardBag-DefaCard-title-state">未激活</span></p>
              <p v-else-if="ercardmber.state == '1'">{{ercardmber.cardtypename}}<span class="CardBag-DefaCard-title-state">正常</span></p>
              <p v-else-if="ercardmber.state == '2'">{{ercardmber.cardtypename}}<span class="CardBag-DefaCard-title-state">挂失</span></p>
              <p>NO.{{ercardmber.cnumber}}</p>
            </div>
            <div class="CardBag-DefaCard-title">
              <p>余额: {{Math.floor(ercardmber.totalamount * 100) / 100 || '0'}}</p>
              <p v-if="ercardmber.cardtypename != '欧宝卡'">积分: {{Math.floor(ercardmber.totalintegral * 100) / 100 || '0'}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="CardBag-operation">
        <div class="CardBag-operation-default CardBag-operation-apply"><router-link :to="{path: 'NewCape'}">申请新卡</router-link></div>
        <div class="CardBag-operation-default"><router-link :to="{path: 'BindCard',query: {castus: '3'}}">绑卡</router-link></div>
      </div>
    </div>
    <!-- 失败提示 -->
    <div id="warnToast" :style="'display:' + cardfail">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-warn weui-icon_toast"></i>
        <p class="weui-toast__content">{{cardtips}}</p>
      </div>
    </div>
    <!-- 加载中 -->
    <PageLong :style="'display:' + cardlong"></PageLong>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      CaCardBag: '',
      loginID: '',
      cardfail: 'none',
      cardtips: '',
      cardmber: '',
      cacaus: '',
      caacnt: '',
      campte: '',
      cardlong: 'block'
    }
  },
  created () {
    // 从缓存里获取token
    this.loginID = localStorage.getItem("usertoken");
    // 接收首页(输入卡号)传过来的状态
    this.CaCardBag = this.$route.query.HoCardBag;
    // 接收输入卡号传过来的状态
    this.cacaus = this.$route.query.secaus;
    // 接收转账传过来的一卡通账户卡号
    this.caacnt = this.$route.query.tracnt;
    // 接收转账(余额)传过来的跳转的状态
    this.campte = this.$route.query.sempte;
    this.$axios.post('app/appUserOldCardPackage',this.$qs.stringify({
      token: this.loginID
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.cardlong = 'none';
      if(res.data.code == '200'){
        this.cardmber = res.data.data;
      }else{
        this.cardtips = res.data.msg;
        this.cardfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.cardfail = 'none';
        },1200)
      }
    })
    .catch(() => {
      console.log('获取失败');
    });
  },
  mounted () {

  },
  methods: {
    // 点击跳转到输入卡号
    careus(carame,caresd,carace,careal,carast,calont,catarl){
      if(this.CaCardBag == '0'){
        this.$router.push({name: 'CardDetails',query: {cacrme: carame,cacter: caresd,cabace: carace,cainal: careal,casate: carast}});
      }else if(this.CaCardBag == '1'){
        this.$router.push({name: 'MyBill',query: {catfbr: caresd}});
      }else if(this.CaCardBag == '2'){
        this.$router.push({name: 'SelectCard',query: {HoSelect: this.cacaus,cactrd: caresd,carale: carace,caingl: careal,calknt: calont,persalge: this.campte,catral: catarl}});
      }else if(this.CaCardBag == '3'){
        this.$router.push({name: 'AgstOpel',query: {exsebr: caresd}});
      }else if(this.CaCardBag == '4'){
        this.$router.push({name: 'balance',query: {sechbr: caresd,sebace: carace,seinal: careal,selent: calont,sepste: this.campte}});
      }else if(this.CaCardBag == '5'){
        this.$router.push({name: 'TranActs',query: {sechbr: caresd,carmon: this.caacnt}});
      }else if(this.CaCardBag == '6'){
        this.$router.push({name: 'TranPost',query: {sechbr: caresd}});
      }else if(this.CaCardBag == '7'){
        this.$router.push({name: 'PlayOpel',query: {sechbr: caresd}});
      }
    },
    // 返回上一层
    BackLevel(){
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>
  @import "obraocs/CardBag.css";
</style>